export default __webpack_public_path__ + "static/media/index-culture.10669a75.jpg";